export const enableRowGroupByColumnProps = {
  disableColumnSelector: true,
  disableColumnMenu: false,
  disableColumnPinning: true,
  disableRowGrouping: false,
  disableAggregation: true,
};
export const disableRowGroupByColumnProps = {
  disableColumnSelector: true,
  disableColumnMenu: false,
  disableColumnPinning: true,
  disableRowGrouping: true,
  disableAggregation: true,
};